// extracted by mini-css-extract-plugin
module.exports = {"events":"Events_events__V9zIh","events__item":"Events_events__item__5Vghw","events__container":"Events_events__container__EJppD","events__pic":"Events_events__pic__6hB3u"};